<template>
    <div>
        <Form :model="query" :label-width="40" inline>
        <FormItem label="标题">
          <Input v-model="query.title"></Input>
        </FormItem>
        <FormItem label="状态">
          <Select v-model="query.status" clearable>
            <Option :value="1" :key="1">可用</Option>
            <Option :value="0" :key="0">不可用</Option>
          </Select>
        </FormItem>
        <FormItem label="">
            <Button type="primary" style="margin-bottom: 6px; margin-left: 6px;" icon="ios-search" @click="loadData">查询</Button>
            <Button type="primary" style="margin-bottom: 6px; margin-left: 6px;"  @click="create">创建</Button>
        </FormItem>
        </Form>

        <!-- 表格&分页 -->
        <Table border :columns="columns" :data="data">
          <template slot-scope="{ row }" slot="action">
            <Button type="primary" size="small" style="margin-right: 5px" @click="update(row)" v-check-auth="'/statistics-record/update'">编辑</Button>
            <Button type="primary" size="small" style="margin-right: 5px" @click="getList(row)" v-check-auth="'/statistics-record/list'">内容</Button>
          </template>
        </Table>
        <Page :total="totalCount" @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" size="small" show-total show-elevator show-sizer :page-size-opts="[20,50,100]" :page-size="perPage"/>
        
        <Modal v-model="createModal" :title="submitType === 'create' ? '创建' : '编辑'" @on-ok="submit">
          <Form :model="form" :label-width="60">
            <FormItem label="标题">
              <Input v-model="form.title"></Input>
            </FormItem>
            <FormItem label="状态">
              <Select v-model="form.status">
                <Option :value="1" :key="1">可用</Option>
                <Option :value="0" :key="0">不可用</Option>
              </Select>
            </FormItem>
            <FormItem label="密码">
              <Input v-model="form.password"></Input>
            </FormItem>
            <FormItem label="最大访问次数">
              <Input v-model="form.access_max_count" placeholder="不填写默认为100"></Input>
            </FormItem>
          </Form>
        </Modal>

        <Modal v-model="listModal" title="内容" :footer-hide="true" width="50%">
          <Table :columns="columnsList" :data="dataList">
            <template slot-scope="{ row }" slot="action">
              <Button type="primary" size="small" style="margin-right: 5px" @click="listUpdate(row)" v-check-auth="'/statistics-record-list/update'">编辑</Button>
              <Button type="error" size="small" style="margin-right: 5px" @click="listDel(row)" v-check-auth="'/statistics-record-list/delete'">删除</Button>
            </template>
          </Table>
          <Button type="primary" size="small" style="margin-top: 10px" @click="addList()" v-check-auth="'/statistics-record-list/create'">添加内容</Button>
        </Modal>

        <Modal v-model="addListModal" :title="submitType === 'create' ? '创建' : '编辑'" @on-ok="submitList">
          <Form :model="listForm" :label-width="60">
            <FormItem label="标题">
              <Input v-model="listForm.title"></Input>
            </FormItem>
            <FormItem label="状态">
              <Select v-model="listForm.type">
                <Option :value="1" :key="1">顶部</Option>
                <Option :value="2" :key="2">下部</Option>
              </Select>
            </FormItem>
            <FormItem label="文件">
              <import-upload url="/files" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" @success="importSuccess"></import-upload>
              <span style="color: red;">尽量按照同样的宽高去上传图片，不要过大或过小，宽高比例合适</span>
            </FormItem>
          </Form>
        </Modal>
    </div>
</template>

<script>
import { StatisticsRecord, StatisticsRecordList } from '@/services/resources'

import ImportUpload from '@/components/ImportUpload'

export default {
    name: 'statisticsRecordIndexPage',
    components: {
      ImportUpload
    },
    data () {
        return {
          data: [],
          dataList: [],
          totalCount: null,
          perPage: 20,
          page: 1,
          query: {},
          form: {},
          listForm: {},
          selectRow: {},
          createModal: false,
          listModal: false,
          addListModal: false,
          submitType: 'create',
          columns: [
            {
              title: '标题',
              key: 'title'
            },
            {
              title: '状态',
              key: 'status',
              width: '50px'
            },
            {
              title: '密码',
              key: 'password',
              width: '150px'
            },
            {
              title: '访问链接',
              key: 'front_url'
            },
            {
              title: '访问次数',
              key: 'access_count',
              width: '100px'
            },
            {
              title: '最大访问次数',
              key: 'access_max_count',
              width: '100px'
            },
            {
              title: '创建时间',
              key: 'created_at',
              width: '130px'
            },
            {
              title: '操作',
              width: 180,
              slot: 'action',
              align: 'center'
            }
          ],
          columnsList: [
            {
              title: '标题',
              key: 'title'
            },
            {
              title: '类型',
              key: 'type_name'
            },
            {
              title: '文件',
              render: (h, params) => {
                return (
                  <div>
                    {params.row.file_path ? <div><a href={params.row.file_path} target="blank">查看</a></div> : <div/>}
                  </div>
                )
              }
            },
            {
              title: '操作',
              width: 180,
              slot: 'action',
              align: 'center'
            }
          ]
        }
    },
    created () {
      this.loadData()
    },
    methods: {
        async loadData () {
          let params = Object.assign({}, { 'per-page': this.perPage, 'page': this.page }, this.query)
          let resp = await StatisticsRecord.query(params)
          this.data = resp.data
          this.totalCount = parseInt(resp.headers['x-pagination-total-count'])
        },
        create () {
          this.createModal = true
          this.submitType = 'create'
        },
        submit () {
          if (this.submitType === 'create') {
            StatisticsRecord.create(this.form).then(res => {
              this.$Message.success('创建成功')
              this.loadData()
            })
          }
          if (this.submitType === 'update') {
            StatisticsRecord.update(this.form).then(res => {
              this.$Message.success('编辑成功')
              this.loadData()
            })
          }
        },
        update (row) {
          this.createModal = true
          this.submitType = 'update'
          this.form = row
        },
        getList (row) {
          this.selectRow = row
          StatisticsRecordList.query({ 'statistics_record_id': row.id }).then(res => {
            this.dataList = res.data
          })
          this.listModal = true
        },
        addList () {
          this.addListModal = true
          this.submitType = 'create'
        },
        importSuccess (res) {
          this.listForm.file = res.path
          this.$Message.success('上传成功')
        },
        submitList () {
          if (this.submitType === 'create') {
            this.listForm.statistics_record_id = this.selectRow.id
            StatisticsRecordList.create(this.listForm).then(res => {
              this.$Message.success('添加成功')
              this.getList(this.selectRow)
            })
          }
          if (this.submitType === 'update') {
            StatisticsRecordList.update(this.listForm).then(res => {
              this.$Message.success('编辑成功')
              this.getList(this.selectRow)
            })
          }
        },
        listUpdate (row) {
          this.addListModal = true
          this.submitType = 'update'
          this.listForm = row
        },
        listDel (row) {
          StatisticsRecordList.delete({ id: row.id }).then(res => {
            this.$Message.success('删除成功')
            this.getList(this.selectRow)
          })
        },
        handlePageChange (page) {
          this.page = page
          this.loadData()
        },
        handlePageSizeChange (perPage) {
          this.perPage = perPage
          this.loadData()
        }
    }
}
</script>
